import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks";
import { IAuthenticationExternalApi } from "@pbm/registration-policies/contracts/authenticationExternalApi";

export function useCreateAuthenticationExternalApi() {
  const { request } = usePbm2Url();
  return useMutation(async (input: any) => {
    const { Rules_createAuthenticationExternalApi } = await request(
      gql`
        mutation ($input: Rules_AuthenticationExternalApiInput!) {
          Rules_createAuthenticationExternalApi(input: $input) {
            authenticationExternalApi {
              id
              RegistrationPolicyCode
              url
              method
              token
              header {
                key
                value
              }
              form {
                type
                key
                value
              }
              createdAt
              updatedAt
            }
            errors {
              code
              message
            }
          }
        }
      `,
      {
        input: {
          ...input,
        },
      }
    );
    return Rules_createAuthenticationExternalApi as IAuthenticationExternalApi;
  });
}
